import { css } from "styled-components";

export const baseHeading = css`
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  line-height: 1.25;
`;
